import React, { useEffect } from 'react'
import useSWR from 'swr'
import Fetcher from 'lib/fetcher'
import DropDown from 'lib/drop-down'
import AddUserButton from './add-button'
import AddUserForm from './add-form'

const UserDetail = ({ model }) => {
  const { data: me } = useSWR('me', Fetcher)
  const { data: permitted_users, mutate: mutateUsers } = useSWR(
    'permitted-users',
    Fetcher
  )

  const options =
    permitted_users?.map((user) => ({
      label: `${user.name ? `${user.name} - ` : ''}${user.email}`,
      value: user.id,
      email: user.email,
      key: user.id,
    })) || []

  useEffect(() => {
    if (
      options &&
      me &&
      model.permittedUsers.length === 0 &&
      options.find((o) => o.email === me.email)
    ) {
      model.permittedUsers = [
        ...model.permittedUsers,
        options.find((o) => o.email === me.email).value,
      ]
    }
  }, [me, permitted_users])

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex flex-row space-x-3 items-end w-full">
        <DropDown
          label="Add a node for user"
          options={options}
          value={model.permittedUsers}
          permitMultiple={true}
          onChange={(value) => {
            model.permittedUsers = value
          }}
          containerClassName="w-full"
        />
        <AddUserButton model={model} />
      </div>
      {model.addingUser && <AddUserForm model={model} mutate={mutateUsers} />}
    </div>
  )
}

export default UserDetail
